import { Reducer } from 'redux';
import { ActionType, getType } from 'typesafe-actions';
import { UIActions } from './UIActions';
import UIStateHelper from './UIStateHelper';
import { initialUIState, IUIState } from './IUIState';

export const UIReducer: Reducer<IUIState> = (
    state: IUIState = initialUIState,
    action: ActionType<typeof UIActions>
) => {
    switch (action.type) {
        case getType(UIActions.showPopup):
            state = UIStateHelper.showPopup(
                state,
                action.payload.popupID,
                action.payload.params
            );
            break;
        case getType(UIActions.hidePopup):
            state = UIStateHelper.hidePopup(
                state,
                action.payload.popupID,
                action.payload.params
            );
            break;
        case getType(UIActions.queuePopup):
            state = UIStateHelper.queuePopup(
                state,
                action.payload.popupID,
                action.payload.params
            );
            break;
        case getType(UIActions.updateParams):
            state = UIStateHelper.updateParams(
                state,
                action.payload.id,
                action.payload.popupID,
                action.payload.params
            );
            break;
    }
    return state;
};
